// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.range-picker .month-picker {\n  width: calc(200% + 10px);\n}\n.range-picker .range-picker__date-picker:last-child .month-picker {\n  left: calc(-100% - 10px);\n}\n", ""]);
// Exports
module.exports = exports;
